import React from 'react';
import res1 from "../assets/download.jpg";
import res2 from "../assets/download (1).jpg";
import res3 from "../assets/download (2).jpg";
import res4 from "../assets/download (3).jpg";
import bettery from "../assets/battery.jpg";
import bettery1 from "../assets/battery1.jpg";
import bettery2 from "../assets/battery2.jpg";
import bettery3 from "../assets/battery3.jpg";
import storage from "../assets/storage.jpg";
import storage1 from "../assets/storage1.jpg";
import storage2 from "../assets/storage2.webp";
import storage3 from "../assets/storage4.jpg";
import "./Gallery.css";

function Gallery() {
    return (
        <>
            <section className="gallery-section">
                <h2 className="gallery-title">Solar Gallery</h2>
                <div className="gallery-grid">
                    <div className="gallery-item">
                        <img src={res1} alt="Gallery Item 1" />

                    </div>

                    <div className="gallery-item">
                        <img src={res4} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={res2} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={res3} alt="Gallery Item 1" />
                    </div>
                </div>
            </section>
            <section className="gallery-section">
                <h2 className="gallery-title">Battery Gallery</h2>
                <div className="gallery-grid">
                    <div className="gallery-item">
                        <img src={bettery} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={bettery1} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={bettery2} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={bettery3} alt="Gallery Item 1" />
                    </div>
                </div>
            </section>
            <section className="gallery-section">
                <h2 className="gallery-title">Storage Gallery</h2>
                <div className="gallery-grid">
                    <div className="gallery-item">
                        <img src={storage} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={storage1} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={storage2} alt="Gallery Item 1" />
                    </div>
                    <div className="gallery-item">
                        <img src={storage3} alt="Gallery Item 1" />
                    </div>
                </div>
            </section>
        </>

    )
}
export default Gallery;